<template>
  <div class="zhifubao">
    <div class="zhifubaoTextBox">
      <img src="../assets/images/zhifubaoText.png" alt="" />
    </div>
    <div v-if="isGO" class="text" style="padding-bottom: 50px">
      <div style="margin-bottom: 10px">即将前往支付宝进行付款</div>
      <i class="el-icon-loading" style="font-size: 25px"></i>
    </div>

    <div v-else class="text">
      <div style="margin-bottom: 40px">付款成功即可点击下一步进行创建</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["openURL"],
  data() {
    return {
      isGO: true,
      num: 1,
    };
  },

  mounted() {
    this.init();

  },

  activated: function () {
  },

  methods: {
    init: function () {
      if (this.num === 1) {
        this.isGO = true;
        setTimeout(() => {
          window.open(this.openURL);
          this.isGO = false;
          this.num = 0;
        }, 2000);
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.zhifubao {
  background: #fff;
}

.zhifubaoTextBox {
  width: 100%;
  text-align: center;
  margin: 97px 0 17px;
  img {
    display: inline-block;
    vertical-align: middle;
  }
}
.text {
  color: #333333;
  font-size: 18px;
  text-align: center;
}
</style>